import type { CSSProperties } from 'react';
import { Dropdown } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import SolarIcon from 'components/icons/SolarIcon';
import SvgLink from 'components/svg/SvgLink';
import SvgTrash from 'components/svg/SvgTrash';
import { useToast } from 'context/ToastContext';
import { copyToClipboard } from 'utils/helpers/copyToClipboard';

interface ItemDropdownProps {
    canDelete?: boolean;
    deleting?: boolean;
    copyUrl?: string;
    onDelete?: () => void;
    style?: CSSProperties;
}

const ItemDropdown = ({ canDelete, deleting, copyUrl, onDelete, style }: ItemDropdownProps) => {
    const { t } = useTranslation(['FileNavigator', 'common']);
    const { showToast } = useToast();

    if (!canDelete && !copyUrl) return null;

    const handleCopyUrl = async () => {
        if (!copyUrl) return;
        const copied = await copyToClipboard(copyUrl);
        showToast(copied ? t('oneFileCopiedUrl') : t('common:messError'), copied ? 'success' : 'danger');
    };

    const menu = (
        <Dropdown.Menu className="shadow-sm files-item-menu" popperConfig={{ strategy: 'fixed' }} renderOnMount>
            {copyUrl ? (
                <Dropdown.Item onClick={() => void handleCopyUrl()}>
                    <SvgLink /> {t('oneFileCopyUrl')}
                </Dropdown.Item>
            ) : null}
            {canDelete ? (
                <Dropdown.Item disabled={deleting} className="text-danger" onClick={onDelete}>
                    <SvgTrash className="text-danger" />
                    {t('oneFileDelete')}
                </Dropdown.Item>
            ) : null}
        </Dropdown.Menu>
    );

    return (
        <Dropdown align="end" className="user-popup" style={style}>
            <Dropdown.Toggle className="file-item-menu-btn" size="sm" variant="light-secondary">
                <SolarIcon name="three-dots" />
            </Dropdown.Toggle>
            {typeof document !== 'undefined' ? createPortal(menu, document.body) : menu}
        </Dropdown>
    );
};

export default ItemDropdown;
